document.addEventListener("DOMContentLoaded", () => {
  const wrappers = document.querySelectorAll(".as-master-chefs__wrapper");

  wrappers.forEach((wrapper) => {
    const scroller = wrapper.querySelector("[data-master-chefs-scroller]");
    const progress = wrapper.querySelector(".as-master-chefs__progress");
    const fill = wrapper.querySelector("[data-master-chefs-progress]");

    if (!scroller || !progress || !fill) return;

    function updateScrollbar() {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;

      if (maxScroll <= 1) {
        progress.classList.remove("is-visible");
        fill.style.width = "100%";
        fill.style.transform = "translateX(0px)";
        return;
      }

      progress.classList.add("is-visible");

      const visibleRatio = scroller.clientWidth / scroller.scrollWidth;
      const fillWidthPercent = Math.max(visibleRatio * 100, 18);
      const scrollRatio = scroller.scrollLeft / maxScroll;

      const trackWidth = fill.parentElement.offsetWidth;
      const fillWidthPx = (trackWidth * fillWidthPercent) / 100;
      const maxMovePx = trackWidth - fillWidthPx;

      fill.style.width = `${fillWidthPercent}%`;
      fill.style.transform = `translateX(${scrollRatio * maxMovePx}px)`;
    }

    updateScrollbar();

    scroller.addEventListener("scroll", updateScrollbar, { passive: true });
    window.addEventListener("resize", updateScrollbar);

    setTimeout(updateScrollbar, 300);
  });
});
